import React, { Component } from 'react';

export default class NavBar extends Component {
    render(){
        return (
            <div className="NavBar">
                <div className="container flex vertical">
                    <div className="flex-1 flex horizontal">
                        <div className="flex-1 flex flex-center">
                            <img alt="Logo" src={`${process.env.PUBLIC_URL}/media/image/logo.jpg`} />
                        </div>
                        <div className="flex-1 flex horizontal-only">
                            <div className="flex-1 flex flex-center link">
                                Minha conta
                            </div>
                            <div className="flex-1 flex flex-center link">
                                Cadastrar
                            </div>
                            <div className="flex-1 flex flex-center link">
                                Login
                            </div>
                            {/* <div className="flex-1 flex flex-center">
                                <span className="text-center">TELEFONE:<br />(11) 4372-7073</span>
                            </div> */}
                        </div>  
                    </div>
                    <div className="flex-1">
                        <div className="Pesquisa">
                            <input
                                name="pesquisa"
                                placeholder="Digite aqui o que procura..."
                                className="form-input" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}